var map = {
	"./Fur/Black/Ears.png": 1694,
	"./Fur/Black/Eyes/Angry.png": 7001,
	"./Fur/Black/Eyes/Bored.png": 5794,
	"./Fur/Black/Eyes/Dollars.png": 5945,
	"./Fur/Black/Eyes/Glow.png": 8762,
	"./Fur/Black/Eyes/Normal.png": 5693,
	"./Fur/Black/Eyes/Scar.png": 3636,
	"./Fur/Black/Fur.png": 9067,
	"./Fur/Black/Mouth/Cigar.png": 6470,
	"./Fur/Black/Mouth/Hungry.png": 7335,
	"./Fur/Black/Mouth/Laughing.png": 678,
	"./Fur/Black/Mouth/Normal.png": 8250,
	"./Fur/Brown/Ears.png": 5506,
	"./Fur/Brown/Eyes/Angry.png": 7296,
	"./Fur/Brown/Eyes/Bored.png": 1591,
	"./Fur/Brown/Eyes/Dollars.png": 5295,
	"./Fur/Brown/Eyes/Glow.png": 8006,
	"./Fur/Brown/Eyes/Normal.png": 9313,
	"./Fur/Brown/Eyes/Scar.png": 109,
	"./Fur/Brown/Fur.png": 5511,
	"./Fur/Brown/Mouth/Cigar.png": 8119,
	"./Fur/Brown/Mouth/Hungry.png": 1461,
	"./Fur/Brown/Mouth/Laughing.png": 6988,
	"./Fur/Brown/Mouth/Normal.png": 9383,
	"./Fur/Coffee/Ears.png": 5052,
	"./Fur/Coffee/Eyes/Angry.png": 2325,
	"./Fur/Coffee/Eyes/Bored.png": 8933,
	"./Fur/Coffee/Eyes/Dollars.png": 5890,
	"./Fur/Coffee/Eyes/Glow.png": 859,
	"./Fur/Coffee/Eyes/Normal.png": 3907,
	"./Fur/Coffee/Eyes/Scar.png": 5346,
	"./Fur/Coffee/Fur.png": 5148,
	"./Fur/Coffee/Mouth/Cigar.png": 7546,
	"./Fur/Coffee/Mouth/Hungry.png": 3013,
	"./Fur/Coffee/Mouth/Laughing.png": 8735,
	"./Fur/Coffee/Mouth/Normal.png": 7070
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4991;